module.exports = __webpack_public_path__ + "static/ogimage-45affb4d9bf48d4a2494966ff9c46efc.jpg";